<template>
  <v-card outlined class="rounded-card">
    <v-subheader>Links</v-subheader>
    <v-divider/>
    <px-lista-links :links="links" :loading="loading"/>
  </v-card>
</template>
<script>
import CotacaoService from '../../cotacao-service';

export default {
  props: {
    idCotacao: {
      type: [Number, Array],
      required: true,
    },
  },
  data() {
    return {
      links: null,
      loading: false,
    };
  },
  methods: {
    getLinks() {
      this.loading = true;

      CotacaoService.getLinks(this.idCotacao)
        .then((response) => {
          this.links = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getLinks();
  },
};
</script>
<style scoped>
.empty {
  width: 100%;
  height: auto;
  background: #fff;
}
</style>
